/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Per_MtokInputs */



/**
* | output |
* | --- |
* | "per 1M tokens" |
*
* @param {Model_Showcase_Per_MtokInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_per_mtok = /** @type {((inputs?: Model_Showcase_Per_MtokInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Per_MtokInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("pro 1 Mio. Token")
	return /** @type {LocalizedString} */ ("per 1M tokens")
});